/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthDeviceResponse } from '../../models/auth-device-response';
import { AuthOtcVerifyRequest } from '../../models/auth-otc-verify-request';

export interface AuthDeviceVerify$Params {

/**
 * uuid key of the tenant
 */
  'X-Tenant-Key'?: string;
      body: AuthOtcVerifyRequest
}

export function authDeviceVerify(http: HttpClient, rootUrl: string, params: AuthDeviceVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthDeviceResponse>> {
  const rb = new RequestBuilder(rootUrl, authDeviceVerify.PATH, 'post');
  if (params) {
    rb.header('X-Tenant-Key', params['X-Tenant-Key'], {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthDeviceResponse>;
    })
  );
}

authDeviceVerify.PATH = '/api/v1/auth/device/verify';
